export const isPopupScrolledToBottom = (
  target: Pick<HTMLElement, 'clientHeight' | 'scrollHeight' | 'scrollTop'>,
) =>
  target.scrollHeight > target.clientHeight &&
  target.scrollTop + target.clientHeight >= target.scrollHeight - 1;
